import "react";
import { ToggleSwitch } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/components/FormikFields/FormikToggleSwitch.tsx
var FormikToggleSwitch = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => /* @__PURE__ */ jsx(ToggleSwitch, {
			...props,
			error: (meta.touched || !!form.submitCount) && meta.error,
			valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
			...field,
			active: !!field.value,
			onBlur: (e) => {
				if (props.onBlur) props.onBlur(e);
				field.onBlur(e);
			},
			onChangeValue: (newValue) => {
				if (props.onChange) props.onChange(newValue);
				props.name && form.setFieldValue(props.name, newValue);
			}
		})
	});
};
//#endregion
export { FormikToggleSwitch };

//# sourceMappingURL=FormikToggleSwitch.js.map